import React, { useState } from 'react';
import '../Checkbox/Checkbox.scss';
import { CheckBoxUntick, CheckboxTick } from '../flyfishIcons/icons';
import styled from 'styled-components';

type CheckboxProps = {
	isChecked: Array<boolean>;
	index: number;
	onValueChange: React.Dispatch<Array<boolean>>;
	label?: string | React.ReactNode;
	fill?;
} & React.ComponentProps<'input'>;

const CHECKBOX = styled.div`
	&.ff-checkbox {
		& > input {
			display: none;
		}
		& > label {
			display: flex;
			align-items: center;
			gap: 12px;
			& > .check {
				display: flex;
				cursor: pointer;
				transition: all 0.2s ease-out;
			}
			& > .label {
				line-height: 1.3;
				font-weight: 500;
			}
		}
	}
`;

const Checkbox = ({
	label,
	isChecked,
	index,
	onValueChange,
	fill,
	...rest
}: CheckboxProps) => {
	const [id] = useState(
		'checkbox_' + Math.random().toString(36).substring(2, 7) //NOSONAR
	);

	const handleChange = () => {
		onValueChange(isChecked.map((check, i) => (i === index ? !check : check)));
	};

	return (
		<CHECKBOX className='ff-checkbox'>
			<input
				type='checkbox'
				name={id}
				id={id}
				checked={isChecked[index]}
				onChange={handleChange}
				{...rest}
			/>
			<label htmlFor={id}>
				<div className={`check ${isChecked[index] ? 'checked' : ''}`}>
					{isChecked[index] ? (
						<CheckboxTick fill={fill} />
					) : (
						// <InteractiveButton icon={<CheckboxTick />} />
						<CheckBoxUntick fill={fill} />
						// <InteractiveButton icon={<CheckBoxUntick />} />
					)}
				</div>
				{label && <span className='label'>{label}</span>}
			</label>
		</CHECKBOX>
	);
};
export default Checkbox;
